import { AppNames } from 'config/appConfig'
import { AppTypes } from 'types/AppTypes'

export default {
  QUARANTINE_ACTION: {
    path: 'quarantine/action',
    legacyPath: undefined,
    appAccess: [AppNames.enduser, AppNames.admin],
    authorization: {
      appTypeAccess: [
        AppTypes.enduser,
        AppTypes.admin,
        AppTypes.wizard,
        AppTypes.domain,
        AppTypes.helpdesk,
        AppTypes.pdDomainId,
        AppTypes.helpdeskWithPdDomainId,
        AppTypes.domainWithPdDomainId
      ]
    }
  }
}
